import _ from 'lodash';

const autofillParser = data => {
  const { suggestions } = data;
  const isAvailable = _.isObject(suggestions) && !_.isEmpty(suggestions);
  const name = suggestions?.autofill?.shipName || '';
  const contextShippingAddress = {
    ..._.find(suggestions?.addresses, { hash: suggestions?.autofill?.shipAddressHash }),
    fullName: suggestions?.autofill?.shipName,
    regionDescription: suggestions?.addresses?.[0]?.regionDescription
      ? suggestions?.addresses?.[0]?.regionDescription
      : suggestions?.addresses?.[0]?.region,
  };
  const shipCompany = suggestions?.autofill?.shipCompany || '';
  const contextBillingAddress = _.find(suggestions?.addresses, { hash: suggestions?.autofill?.billAddressHash });
  const billName = suggestions?.autofill?.billName;
  const billPhone = suggestions?.autofill?.billPhone;
  const cardId = suggestions?.autofill?.cardId;

  return {
    isAvailable,
    name,
    address1: contextShippingAddress.userInputSingleLine,
    address2: contextShippingAddress.line2,
    shipCompany,
    contextShippingAddress,
    contextBillingAddress,
    billName,
    billPhone,
    cardId,
  };
};

export default autofillParser;
